import React from "react";
import CheckboxOption from "./checkboxOption";
import * as styles from "./styles.module.scss";

/**
 * A single checkbox.
 *
 * @param {string} label - The label text for the checkbox.
 * @param {JSX.Element} [icon] - An icon decoration to be displayed with the label.
 * @param {string} value - The value of the checkbox input.
 * @param {string} name - The name attribute to use for the checkbox input.
 * @param {boolean} isChecked - The checked state of the checkbox input.
 * @param {Function} handleOptionsChange - The function that handles the change of the checkbox input.
 * @returns {JSX.Element} - The Checkbox element.
 */
const Checkbox = ({
  label,
  icon,
  value,
  name,
  isChecked,
  handleOptionsChange,
  layout = "boxed",
  children,
  key,
  className,
  labelClassName
}) => {
  return (
    <label key={key} className={`${styles.checkbox} ${styles[layout]} generalText text-sm leading-[1.01875rem] ${className}`}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleOptionsChange}
        value={value}
      />
      <span className={styles.checkmark}>
        <svg
          className={styles.check}
          width="0.75rem"
          height="0.75rem"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          name={name}
        >
          <path
            d="M6.66668 2.16699L3.00001 5.83366L1.33334 4.16699"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {children}
      <CheckboxOption className={labelClassName} label={label} icon={icon} />
    </label>
  );
};

export default Checkbox;
